<ft-modal-overlay [open]="true">
    <div class="ft-person-modal">
        <header class="ft-person-header">
            <div class="ft-modal-id">
                <h1 class="ft-modal-name ft-text-plus-3">{{ headerAdvocate() ? (headerAdvocate() | fullName: !headerPii()) : '' }}</h1>
            </div>
            <button class="ft-btn-close" (click)="close()"></button>
        </header>
        <main class="ft-main ft-scroll-anchor">
            <section class="ft-master-section ft-touchpoint-master">
                <ft-people-details-body [advocateUuid]="advocateUuid()"
                    [curate]="curate()"
                    (loaded)="onBodyLoaded($event)"
                />
            </section>
        </main>
    </div>
</ft-modal-overlay>
